import { useState } from "react";
import "./NotFoundComponent.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { clickStreamUser } from "../../../utils/AppUtils";
import { useSelector } from "react-redux";
const NotFoundMsg = (props) => {
  const {
    width,
    height,
    showBtn,
    btnName,
    btnAction,
    showMsg,
    msgLine,
    msgLine2,
  } = props;
  const { t } = useTranslation();
  const [svgWidth, setSvgWidth] = useState(width ? width : 400);
  const [svgHeight, setSvgHeight] = useState(height ? height : 419);
  const navigate = useNavigate();
  const authBroker = useSelector((state) => state.auth.authBroker);

  return (
    <>
      <section className="error-box">
        <img
          src="/images/finwell-img/NoSearchResults.svg"
          width={50}
          height={50}
          alt="not found"
        />
        {showMsg ? (
          <>
            <div className="error-msgs">
              {t("get_started_with_the")}{" "}
              <a
                className="right cursor-pointer"
                onClick={() => {
                  clickStreamUser(
                    "get_started_with_money_compass_assessment_clicked",
                    {
                      userId: authBroker?.payload?.user?.user_id,
                    },
                    authBroker,
                  );
                  navigate("/assess");
                }}
                style={{ textDecoration: "none" }}
              >
                {t("money_compass")}
              </a>{" "}
              {t("assessment")}
            </div>
          </>
        ) : (
          ""
        )}
        {/* {
                    showBtn ?
                        <div className="button-design d-flex justify-content-center">
                            <button type="button" className="startcourse-btn" onClick={btnAction}>
                                {btnName}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                >
                                    <path
                                        d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                        stroke="#415385"
                                        strokeWidth="1.66667"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                    :
                        ""
                } */}
      </section>
    </>
  );
};

export default NotFoundMsg;
